/* globals angular, _ */
(function() {
  'use strict';

  function ReversesStatusFilterCtrl (
    mdPanelRef,
    moment,
    localStorageService
  ) {
    var ctrl = this;
    
    ctrl.situacaoEncomenda = ctrl.filters.data &&
      ctrl.filters.data.situacaoEncomenda ||
      null;

    ctrl.close = function () {
      mdPanelRef.close();
    };

    ctrl.clearFields = function () {
      ctrl.filters.data = {
        situacaoEncomenda: ctrl.situacaoEncomenda = null
      };
      ctrl.close();
    };
    ctrl.onSubmit = function (form) {
      
      if (form.$pristine) {
        ctrl.close();
        return;
      }

      var diff = _.filter(form.$$controls, {'$dirty': true});
      
      if (!ctrl.filters.data) {
        ctrl.filters.data = {};
      }

      _.forEach(diff, function(field){
        ctrl.filters.data[field.$name] = field.$modelValue;
      });

      var actionName = 'FilterSituation';
      var actionValue = true;

      ctrl.close();
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReversesStatusFilterCtrl', ReversesStatusFilterCtrl);
}());
